const confirmationModal = {
    header: 'Potwierdź operację',
    body: 'Czy na pewno chcesz wykonać tę operację?',
    confirm: 'OK',
    cancel: 'Anuluj'
};

export default confirmationModal;